// Third-party imports
import $ from 'jquery';
import 'parsleyjs';
import 'parsleyjs/dist/i18n/fr';
import 'parsleyjs/dist/i18n/zh_cn';

// Module name
export const MODULE_NAME = 'validate';

export let global_vars = {};

export function initialize(global) {
    // Initialize parlsey
    init_parsleyjs(global);

    let validatedForms = $('form.js-validate');
    let validateButton = $('body').find('.js-parselyValidate-hook');

    let shared = { validatedForms, validateButton };
    if (formAndButtonExist(shared)) {
        validateWhenNoSubmitInput(shared);
    } else if (formExistsWithoutButton(shared)) {
        validatedForms.parsley();
    }
}

function init_parsleyjs(global) {
    let lang = global.document.querySelector('body').dataset.lang;
    if (lang === '') {
        lang = 'en';
    } else if (lang === 'zh') {
        lang = 'zh-cn';
    }
    global.Parsley.setLocale(lang);
}

function validateWhenNoSubmitInput(shared) {
    shared.validateButton.on('click', e => {
        e.preventDefault();
        let form = $(e.currentTarget)
            .closest('.js-formValidationWrapper-hook')
            .find(shared.validatedForms);
        form.parsley().validate();
    });
}

function formAndButtonExist(shared) {
    return shared.validatedForms.length && shared.validateButton.length;
}

function formExistsWithoutButton(shared) {
    return shared.validatedForms.length && shared.validateButton.length === 0;
}
